<div class="skeleton-loader" *ngIf="statusDetail == 'init'">
  <div class="charging-content" *ngFor="let item of  [0,1,2,3,4,5,6]">
  </div>
</div>

<div *ngIf="statusDetail == 'success'">
  <div *ngIf="totalItemsList > 0" class="table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef class="header-column1"></th>
        <td mat-cell *matCellDef="let element" class="column1">
          <div class="image-container pointer">
            <div *ngIf="element.picture_cover">

              <img *ngIf="element.picture_cover; else noImg" class="image-data" [src]="element.picture_cover"
                alt="no image">

              <ng-template #noImg>
                <div class="container-no-img">
                  <img class="image-data" src="assets/images/noti-image.png" alt="no Image">
                </div>
              </ng-template>
            </div>

            <div class="kind-image-container alt-justify-center"
              [class.video-color]="element.select_theme === 'Finanzas'"
              [class.image-color]="element.select_theme === 'Talento'"
              [class.pdf-color]="element.select_theme === 'Mercado'">
              <p class="kind-image alt-size-10 alt-inter-bold">{{element.select_theme | uppercase}}</p>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef class="header-column2">
          <div class="title-container alt-row-align-center">
            <p class="title_inside  alt-inter-medium alt-color-grayscale2 alt-size-14 ">{{"OPORTUNITIES.column1-header"
              | translate}}</p>
            <div class="order-arrows alt-column-justify-center">
              <mat-icon class="up-order pointer" svgIcon="arrow" (click)="sortingByTitle()"></mat-icon>
              <mat-icon class="down-order pointer" svgIcon="arrow" (click)="sortByTitledown()"></mat-icon>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="colum2" [class.small-size]="menuChange">
          <p class="title-oportunitie alt-inter-medium alt-size-14">
            {{element.opportunity_title}}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef class="text-aling alt-inter-semibold alt-size-14">
          <p class="title_inside alt-inter-medium alt-color-grayscale2 alt-size-14 ">{{"OPORTUNITIES.date-created" |
            translate}}</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="action-container date-container pointer">
            <p class="action-2 alt-inter-medium alt-color-grayscale2 alt-size-14">{{element.created_At}}</p>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="header-column4 alt-inter-semibold alt-size-14">
          <div class="title-container alt-row-align-center">
            <p class="title_inside alt-inter-medium alt-color-grayscale2 alt-size-14">{{"OPORTUNITIES.column2-header" |
              translate}} </p>
            <div class="order-arrows alt-column-justify-center">
              <mat-icon class="up-order pointer" svgIcon="arrow" (click)="sortByUpTipe()"></mat-icon>
              <mat-icon class="down-order pointer" svgIcon="arrow" (click)="sortByDownTipe()"></mat-icon>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="type-container" [class.video-color]="element.type === 'video'"
            [class.image-color]="element.type === 'picture'" [class.pdf-color]="element.type === 'pdf'">
            <p *ngIf="element.type == 'notice'" class="type-text alt-inter-bold alt-size-10">AVISO</p>
            <p *ngIf="element.type == 'video'" class="type-text alt-inter-bold alt-size-10">VIDEO</p>
            <p *ngIf="element.type == 'picture'" class="type-text alt-inter-bold alt-size-10">IMAGEN</p>
            <p *ngIf="element.type == 'pdf'" class="type-text alt-inter-bold alt-size-10">PDF</p>
          </div>

        </td>
      </ng-container>
      <ng-container matColumnDef="likes">
        <th mat-header-cell *matHeaderCellDef class="header-column5"> </th>
        <td mat-cell *matCellDef="let element">
          <div class="like-container alt-justify-center">
            <mat-icon class="heart-icon" svgIcon="heart"></mat-icon>
            <p class="likes-numbers alt-inter-medium alt-size-12">{{element.amount_interested}} </p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="header-column6"></th>
        <td mat-cell *matCellDef="let element">
          <div class="action-container pointer" (click)="goToEditOportunitie(element._id)">
            <p class="action-1 alt-inter-semibold alt-size-14 alt-color-bran1">{{"FACILITATOR.edit" | translate
              |uppercase}}</p>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="erase">
        <th mat-header-cell *matHeaderCellDef class="header-column7"></th>
        <td mat-cell *matCellDef="let element">
          <div class="action-container pointer" (click)="openDialogDelete(element._id)">
            <p class="action-2 alt-inter-semibold alt-size-14 alt-color-system">{{"OPORTUNITIES.delete"| translate |
              uppercase }}</p>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator class="paginator" [pageSizeOptions]="[itemsPerPage]" aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>
